
export const Cookies = {};

Cookies.set = function(name, value, expirationDays) {
	var expiration = new Date();
	expiration.setTime(expiration.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

	document.cookie = name + "=" + value + ";expires=" + expiration.toUTCString() + ";path=/";
}

Cookies.remove = function(name) {
	document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
}

Cookies.get = function(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");

	for (var i = 0; i < ca.length; ++i) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return undefined;
}

Cookies.contains = function(name) {
	return Cookies.get(name) !== undefined;
}
